import type { CustomerModel } from "@/models";
import { computed } from "vue";
import {
    dayPhoneRule,
    firstnameRule,
    middlenameRule,
    postcodeRule,
    surnameRule,
    titleRule,
} from "@/validation";

export const yourDetailsRules = (customer: CustomerModel) =>
    computed(() => ({
        dayPhone: dayPhoneRule(true),
        title: titleRule(customer, true),
        firstname: firstnameRule(customer, true),
        middlename: middlenameRule,
        surname: surnameRule(customer, true),
        address: {
            postcode: postcodeRule,
        },
    }));
